import { useSyncExternalStore } from "react";
import type { ID } from "./id";

// A per-person photo version, the cache-buster MemberPhoto passes as `?v=`.
// The photo URL is stable and the server lets the browser keep it for an
// hour, so a replaced photo would otherwise keep showing the old bytes.
//
// Same idea as the counters the registry and the roster keep in page state,
// but shared and bumped by the upload itself (useUploadPhoto), so a surface
// that did not perform the upload, the person detail dialog, still sees it.
// In memory only: a reload starts at 0 again, as the page counters do.
const versions = new Map<ID, number>();
const listeners = new Set<() => void>();

export function bumpPhotoVersion(personId: ID) {
  versions.set(personId, (versions.get(personId) ?? 0) + 1);
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePhotoVersion(personId: ID): number {
  return useSyncExternalStore(subscribe, () => versions.get(personId) ?? 0);
}
